import React, {Component} from 'react';
import {BrowserRouter as Router, Route} from "react-router-dom";

import Layout from './templates/Layout';

import * as config from './Config'

class App extends Component {
    render() {
        return (
            <Router basename={process.env.PUBLIC_URL}>
                <Layout>
                    {
                        config.pages.map((page) =>
                            <Route key={page.key}
                                   exact path={page.path}
                                   component={page.component}>
                            </Route>)
                    }
                </Layout>
            </Router>
        );
    }
}

export default App;
